<template>
  <div class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content rounded">
        <div class="modal-header py-3">
          <h2 class="fw-bolder">
            Filled Forms
          </h2>
          <!--begin::Description-->
          <!-- <div class="text-gray-400 fw-bold fs-5">
            {{ contents.subTitle.length ? contents.subTitle : "" }}
            <a href="#" class="fw-bolder link-primary">{{
              contents.subTitleLink.length ? contents.subTitleLink : ""
            }}</a>
          </div> -->
          <!--end::Description-->
          <div
            class="btn btn-icon btn-sm btn-active-icon-primary"
            @click="closeModal"
          >
            <span class="svg-icon svg-icon-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <rect
                  opacity="0.5"
                  x="6"
                  y="17.3137"
                  width="16"
                  height="2"
                  rx="1"
                  transform="rotate(-45 6 17.3137)"
                  fill="black"
                />
                <rect
                  x="7.41422"
                  y="6"
                  width="16"
                  height="2"
                  rx="1"
                  transform="rotate(45 7.41422 6)"
                  fill="black"
                />
              </svg>
            </span>
          </div>
        </div>
        <div v-if="scoreDisplay" class="modal-body scroll-y">
          <div class="d-flex flex-column flex-center">
            <div v-for="(form, fi) in modalInfo.items" :key="fi" class="d-flex flex-column justify-content-between aligin-items-center w-100 rounded border border-1 border-dark p-3 mb-5">
              <div class="w-100 d-flex flex-row align-items-center justify-content-between mb-3 pb-2 border-bottom border-bottom-1">
                <h3 class="col-6 text-start">{{ form.formName }}</h3>
                <h3 class="col-6 text-end">{{ form.categoryName }}</h3>
              </div>
              <div class="w-100 d-flex flex-row align-items-center justify-content-between">
                <h3 class="col-11 text-start">{{ form.profileFullName }} ({{ calculateScore }})</h3>
                <a href="#" class="col-1 bi bi-eye" @click="viewForm(form)"></a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer py-3 d-flex justify-content-center">
          <div class="text-center">
            <button class="btn btn-light me-3" @click="closeModal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serverConfigs from "../../configs/server.json";

export default {
  components: {},
  setup() {},
  data() {
    return {
      scoreDisplay: false,
      displayStatus: false,
      value: null,
      modalDisplay: false,
      info: {},
      reason: "",
      hafezliAnswers: []
    };
  },
  props: {
    modalInfo: {
      required: false,
    },
  },
  computed: {
    backendHost() {
      return serverConfigs["serverDomain"]["host"];
    },
    modalOverlay() {
      let elem = document.createElement("div");
      elem.style.cssText = "z-index:109";
      elem.classList.add("drawer-overlay");
      return elem;
    },
    modalNode() {
      return document.getElementsByClassName("modal fade")[0];
    },
    bodyNode() {
      return document.getElementById("kt_body");
    },
    calculateScore() {
      let score = 0
      let totalScore = 0
      // for (let item in this.modalInfo.items) {
      //   for (let q in this.modalInfo.items[item].formJson) {
      //     for (let s in this.modalInfo.items[item].formJson[q]) {
      //       console.log(s)
      //       if (s == 'lead' || s == 'followUp') {
      //         console.log(this.modalInfo.items[item].formJson[q][s])
      //         totalScore += this.modalInfo.items[item].formJson[q][s].quizes.length
      //         for (let a in this.modalInfo.items[item].formJson[q][s].quizes) {
      //           if (this.modalInfo.items[item].formJson[q][s].quizes[a] == this.hafezliAnswers[q][s][a])
      //           console.log()
      //           console.log()
      //         }
      //       } else {
      //         console.log(s)
      //         console.log(this.modalInfo.items[item].formJson[q][s])
      //         for (let t in this.modalInfo.items[item].formJson[q][s]) {
      //           totalScore += this.modalInfo.items[item].formJson[q][s][t].quizes.length
      //           console.log(this.modalInfo.items[item].formJson[q][s][t].quizes)
      //         }
      //       }
      //     }
      //   }
      // }
      console.log(`${score} - ${totalScore}`)
      return 0;
    }
  },
  methods: {
    closeModal(opt, index) {
      this.$emit(
        "close-modal",
        opt.length > 0 ? opt : null,
        index ? index : null
      );
    },
    viewForm(form) {
      this.$router.push(`productView/${form.formName.split('_')[1]}?student=${form.formUser}`);
    },
    formScore() {
      for (let chapter in this.modalInfo.obj['productChapters']) {
        this.hafezliAnswers.push({
          'lead': [],
          'tasks': [],
          'followUp': []
        })
        for (let s in this.modalInfo.obj['productChapters'][chapter]) {
          if ((s == 'lead' || s == 'followUp') && this.modalInfo.obj['productChapters'][chapter][s].quizes.length > 0) {
            console.log(this.modalInfo.obj['productChapters'][chapter][s].quizes)
            for (let q in this.modalInfo.obj['productChapters'][chapter][s].quizes) {
              console.log(this.modalInfo.obj['productChapters'][chapter][s].quizes[q].answer)
              this.hafezliAnswers[chapter][s].push(this.modalInfo.obj['productChapters'][chapter][s].quizes[q].answer)
            }
          } else {
            console.log(this.modalInfo.obj['productChapters'][chapter][s])
            for (let t in this.modalInfo.obj['productChapters'][chapter][s]) {
              this.hafezliAnswers[chapter][s].push([])
              for (let q in this.modalInfo.obj['productChapters'][chapter][s][t].quizes) {
                console.log(this.modalInfo.obj['productChapters'][chapter][s][t].quizes[q].answer)
                this.hafezliAnswers[chapter][s][t].push(this.modalInfo.obj['productChapters'][chapter][s][t].quizes[q].answer)
              }
            }
          }
        }
      }
      this.scoreDisplay = true
    }
  },
  mounted() {
    Object.assign(this.info, this.modalInfo);
    document.addEventListener("keyup", this.detectTabKey);
    document.body.appendChild(this.modalOverlay);
    this.formScore()
    
    // this.info["display"] = true;
    if (this.info.status) {
      for (let field in this.contents.fields) {
        if (
          this.contents.fields[field].type == "array" ||
          this.contents.fields[field].type == "component" ||
          this.contents.fields[field].type == "paragraph"
        ) {
          continue;
        } else {
          this.info[this.contents.fields[field].name] =
            this.contents.fields[field].default;
        }
      }
    }
    this.modalNode.classList.add("show");
    this.modalNode.classList.add("d-block");
    this.bodyNode.classList.add("modal-open");
    this.bodyNode.style.overflow = "hidden";
  },
  unmounted() {
    // document.body.removeChild(this.modalOverlay);
    document.body.removeChild(document.getElementsByClassName("drawer-overlay")[document.getElementsByClassName("drawer-overlay").length - 1])
  },
  updated() {},
};
</script>

<style scoped>
.wrong-inputs {
  border: 2px solid !important;
  border-color: red !important;
  /* background-color: #fff; */
}
</style>
